<template>
    <div class="guaratees-container">
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
        <typo name="body-14-normal" v-if="insurer.body" v-html="insurer.body" />
        <div v-else>
            <div v-for="guarantee in getGuarantees()" :key="guarantee._uid">
                <div v-if="getOptionLabel(guarantee) !== ''" class="guarantee">
                    <typo name="body-14-normal">
                        {{ getOptionLabel(guarantee, true) }}
                    </typo>
                </div>
            </div>

            <div class="des-container">
                <badge v-if="insurer.highSolidarityDegree"> DES </badge>
            </div>
            <div v-if="filteredTags.length > 0" class="tags-container">
                <badge v-for="tag in filteredTags" fontSize="body-12-normal" :key="tag._uid">
                    {{ getOptionLabel(tag, false) }}
                </badge>
            </div>
        </div>
    </div>
</template>

<script>
import { get } from "lodash";
import Badge from "../../../common/Badge.vue";
import contentBody from "src/mixins/contentBody";

export default {
    components: { Badge },
    props: ["insurer", "annotationOptions", "tags"],
    mixins: [contentBody],
    mounted() {
        this.filterContent();
    },
    updated() {
        this.filterContent();
    },
    methods: {
        getGuarantees() {
            return this.insurer.guarantees ? this.insurer.guarantees : [];
        },
        getOptionLabel(code, lowerCase = true) {
            const label = get(this.annotationOptions, `${code}.label`, "");
            return lowerCase ? label.toLowerCase() : label;
        },
        filterContent() {
            this.normalizeTitles();
            this.normalizeArticleLinks();
            this.normalizeArticlesCategoryLinks();
            this.normalizeCCNLinks(this.mode);
            this.normalizeLinkedContentsLinks();
            this.normalizeTable();
        },
    },
    computed: {
        filteredTags() {
            return this.tags.filter(tag => tag !== "compact-info");
        },
    },
};
</script>

<style scoped lang="sass">
.guaratees-container
    display: flex
    flex-direction: column
    width: 300px
    margin: 0 16px
    padding: 0 16px

.guarantee
    position: relative
    margin-left: 9px
    &::first-letter
        text-transform: capitalize
    &:before
        position: absolute
        content: ""
        left: -10px
        top: 9px
        z-index: 1
        height: 5px
        width: 5px
        background-color: $color-main
        box-shadow: 0 0 8px rgba(0,0,0,0.5)

.des-container
    margin-top: 4px

.tags-container
    margin-top: 4px
    padding: 4px
</style>
